module.exports = __webpack_public_path__ + "img/analyticsIcon.117bef16.svg";